import React from 'react';
import styles from '../OrderStatus.module.css';
import { useAjax } from '@developers/use-ajax';
import * as ordersAjax from '../../../ajax/orders';

const DamageClaimsDetails = (props) => {

  const [damageClaimProducts, getDamageClaimProducts, getDamageClaimProductsMeta] = useAjax(ordersAjax.getDamageClaimProducts, []);
  
  React.useEffect(() => {
    if (props.dc?.dc_id) {
      getDamageClaimProducts(props.dc?.dc_id, props.validators.token);
    }
  }, [props.dc]);

  return (
    <>
      <h2 className={styles.heading}>Damage Claim(s) Issued</h2>
      {props.damageClaims.map((dc) => {
        return (
          <table key={dc.dc_id}>
            <tr>
              <td className={styles.detailTitle}>
                <strong>DC#:</strong>
              </td>
              <td className={styles.detail}>
                <strong>{'DC' + dc.dc_id}</strong>
              </td>
            </tr>
            <tr>
              <td className={styles.detailTitle}>
                <strong>Status:</strong>
              </td>
              <td className={styles.detail}>
                {dc.dc_status}
              </td>
            </tr>
            <tr>
              <td className={styles.detailTitle}>
                <strong>Date Issued:</strong>
              </td>
              <td className={styles.detail}>
                {dc.dc_date_approved}
              </td>
            </tr>
            {damageClaimProducts &&
              <tr>
                <td className={styles.detailTitle}>
                  <strong>Parts on DC:</strong>
                </td>
                {damageClaimProducts?.map((product) => {
                  return (
                    <td className={styles.detail} key={product.product_id}>
                      {'Qty ' + product.dc_data.dc_item_qty + ' of '}<a href={product.link}>{product.product_id}</a>{' (' + product.product_name + ')'}
                    </td>
                  );
                })}
              </tr>
            }
          </table>
        );
      })}
    </>
  );
};

export default DamageClaimsDetails;